module.exports = __webpack_public_path__ + "static/media/zu-ZA.1165a32c.md";